import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4 flex-wrap gap-2" }
const _hoisted_3 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mr-4" }, "Pontaj Personal", -1)),
      _createVNode(_component_v_select, {
        modelValue: _ctx.luna,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.luna) = $event)),
          _ctx.incarca
        ],
        items: _ctx.luni,
        "item-title": "text",
        "item-value": "val",
        label: "Luna",
        variant: "outlined",
        density: "compact",
        style: {"max-width":"160px"}
      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
      _createVNode(_component_v_select, {
        modelValue: _ctx.an,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.an) = $event)),
          _ctx.incarca
        ],
        items: _ctx.ani,
        label: "An",
        variant: "outlined",
        density: "compact",
        style: {"max-width":"100px"}
      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_chip, {
        color: "blue-darken-1",
        variant: "tonal"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" Total ore: ", -1)),
          _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.totalOre), 1)
        ]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "red-darken-1",
          class: "mb-2"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.pontaje,
      "show-borders": true,
      "row-alternation-enabled": true
    }, {
      oreCellTemplate: _withCtx(({ data }) => [
        _createTextVNode(_toDisplayString(_ctx.calcOre(data.data.OraInceput, data.data.OraFinal)), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxColumn, {
          "data-field": "Data",
          caption: "Data",
          "data-type": "date",
          format: "dd.MM.yyyy",
          width: 120
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraInceput",
          caption: "Intrare",
          width: 100
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraFinal",
          caption: "Plecare",
          width: 100
        }),
        _createVNode(_component_DxColumn, {
          caption: "Ore lucrate",
          width: 110,
          "cell-template": "oreCellTemplate"
        }),
        _createVNode(_component_DxPaging, { enabled: false })
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}